// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"f697b959","247":"138d3573","495":"b650b000","760":"c04af1ed"}[chunkId] + ".chunk.js";
};